import { FC, SVGProps } from 'react';

export const RedirectIcon: FC<SVGProps<SVGSVGElement>> = props => (
	<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none" {...props}>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M25.7683 6.16484C26.1824 6.17494 26.5099 6.51882 26.4998 6.93291L26.3352 16.6809C26.3251 17.095 25.9812 17.4225 25.5671 17.4124C25.153 17.4023 24.8255 17.0584 24.8356 16.6443L24.9489 9.18114C24.9516 9.00413 24.7399 8.91116 24.6114 9.03288L7.26724 25.4577C6.9673 25.7434 6.49256 25.7318 6.2069 25.4319C5.92123 25.1319 5.93281 24.6572 6.23276 24.3715L23.5649 7.95799C23.6952 7.83467 23.6098 7.61552 23.4305 7.6128L15.9837 7.49981C15.5696 7.48971 15.2421 7.14584 15.2522 6.73175C15.2623 6.31766 15.6062 5.99016 16.0203 6.00026L25.7683 6.16484Z"
			fill="currentColor"
		/>
	</svg>
);
